import ctx from "../../plugins/axios";

/**
 * Gets cascading dropdown options based on field type and selections.
 *
 * @param {Object} params - Parameters for cascading options
 * @param {string} params.field_type - Type of field: 'thpc', 'disease_state', 'molecule', 'brand', 'indication'
 * @param {string} params.department_field - Department: 'RETAIL' or 'MEDICAL'
 * @param {string} params.list_type - List type: 'brnd&ind', 'thpc&dsst&mdpr', 'thpc&dsst'
 * @param {string} params.clone_type - Clone type: 'scratch' or 'existing'
 * @param {string} [params.thpc_nm] - Selected THPC name (required for non-thpc field types)
 * @param {string} [params.dsst_nm] - Selected disease state name (required for molecule, brand, indication)
 * @param {string} [params.brand_nm] - Selected brand name (required for indication)
 * @returns {Promise<*>}
 */
const getCascadingOptions = async (params) => {
  const searchParams = new URLSearchParams();
  
  // Add required parameters
  searchParams.append('field_type', params.field_type);
  searchParams.append('department_field', params.department_field);
  searchParams.append('list_type', params.list_type);
  searchParams.append('clone_type', params.clone_type);
  
  // Add optional cascading parameters
  if (params.thpc_nm) {
    searchParams.append('thpc_nm', params.thpc_nm);
  }
  if (params.dsst_nm) {
    searchParams.append('dsst_nm', params.dsst_nm);
  }
  if (params.brand_nm) {
    searchParams.append('brand_nm', params.brand_nm);
  }

  return await ctx.get(`/therapeutic?${searchParams.toString()}`);
};

export default getCascadingOptions;
